export const createAdUnitCode = (slotName) => {
	let _adData;

	const { adData = {}, adDataAdc } = window.tagEngineDataLayer;

	if (adDataAdc) {
		_adData = adDataAdc;
	} else {
		const pageFromPath = window.location.pathname.replace('/app', '').replaceAll('/', '');
		const pageId = pageFromPath || 'home';
		_adData = adData[pageId];
	}

	const firstSlot = Object.values(_adData?.adSlots || {}).find(slot => slot?.adUnitCode);

	if (firstSlot?.adUnitCode) {
		let adUnitCode = firstSlot.adUnitCode.split('/');
		adUnitCode[4] = slotName;
		return adUnitCode.join('/').replace('-p', '').replace('-v', '');
	}

	return '';
};
